import * as React from 'react';

import('./PlayerNamesStyles.scss')   



const PlayerNamesPresentation = (props:any) => {
    return (
        <div className={`playerNames`}>
            {createPlayerTemplate('home', props.names.home, props.flags.home)}
            {createPlayerTemplate('away', props.names.away, props.flags.away)}
        </div>
    );
};

const createPlayerTemplate = (homeOrAway:string, name:string, flagSrc:string) => {

    const nameDOM:any = (
        <span key={`${homeOrAway}-flag`} className={`name`}>{name}</span>
    );
    const flagDOM:any = (
        <span key={`${homeOrAway}-name`} className={`flag`}>
            <img src={flagSrc}/>
        </span>
    );

    return (
        <div className={`playerWrapper ${homeOrAway}`}>
            {/*check for home or away and return the elements in the right order*/}
            {homeOrAway === 'home' ? [flagDOM, nameDOM] : [nameDOM, flagDOM]}

            <div className={`bottomLine`}>&nbsp;</div>
        </div>
    );
};

export default PlayerNamesPresentation;